// The languages an appointment's AI summary may be translated into.
//
// MIRRORED BY HAND from SUMMARY_TRANSLATION_LANGUAGES in
// Backend/api/controllers/appointmentController.js — keep the two identical.
// POST /appointment/:id/summary-translate refuses any other code with
// 400 UNSUPPORTED_LANGUAGE (R6, 15 Sep 2026): the language name used to come
// from the client and went straight into the AI prompt. The translate
// dropdown (components/AppointmentSummary.jsx) is filled from the master
// language table, which can hold languages the server will not translate
// into, so it offers only the codes listed here.
//
// summaryTranslationLanguages.test.js reads the backend file's source text and
// fails when this list drifts from it.
export const SUMMARY_TRANSLATION_LANGUAGES = Object.freeze({
    en: 'English',
    fr: 'French',
    ta: 'Tamil',
    hi: 'Hindi',
    te: 'Telugu',
    kn: 'Kannada',
    ml: 'Malayalam',
    mr: 'Marathi',
    bn: 'Bengali',
    gu: 'Gujarati',
    pa: 'Punjabi',
    ur: 'Urdu',
    or: 'Odia',
    es: 'Spanish',
    de: 'German',
    it: 'Italian',
    pt: 'Portuguese',
    nl: 'Dutch',
    ar: 'Arabic',
    zh: 'Chinese',
    ja: 'Japanese',
    ru: 'Russian',
});

// The server's own reading of a code: trimmed, lower-cased, region dropped
// ("hi-IN" and "hi_in" are Hindi).
export const baseLanguageCode = (code) =>
    (typeof code === 'string' ? code.trim().toLowerCase().split(/[-_]/)[0] : '');

/** Will the server translate a summary into this language code? */
export const isSummaryTranslationLanguage = (code) => {
    const base = baseLanguageCode(code);
    return !!base && Object.prototype.hasOwnProperty.call(SUMMARY_TRANSLATION_LANGUAGES, base);
};
